var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Puzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_24-Puzzle",
    "data-name": "24-Puzzle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20052",
    d: "M27.00005,2.00389V11h-2a4,4,0,0,0,0,8h2v8h8V25a4,4,0,0,1,8,0v2H52.004V5A3.01737,3.01737,0,0,0,48.9981,2.00389Z",
    fill: "#fc6067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,5V27H48V5a3.02183,3.02183,0,0,0-3-3h4A3.02183,3.02183,0,0,1,52,5Z",
    fill: "#fb4b5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.00006,18.99994a4,4,0,0,1,0-8h2V2.00385H5.002a3.01568,3.01568,0,0,0-3.0039,2.99609v22h9.00195v2a4,4,0,0,0,8,0v-2h8v-8Z",
    fill: "#68b1fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.00006,34.99994h-2v-8h-8v2a4,4,0,0,1-8,0v-2H1.99811V48.996A3.02408,3.02408,0,0,0,5.002,52.00189H27.00006v-9.002h2a4,4,0,0,0,0-8Z",
    fill: "#fcb860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.00006,34.99994h-2v-8h-8v2a4,4,0,0,1-8,0v-2H1.99811V48.996A3.02408,3.02408,0,0,0,5.002,52.00189H27.00006v-9.002h2a4,4,0,0,0,0-8Z",
    fill: "#fcb860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.00006,34.99994h-2v-8h-8v2a4,4,0,0,1-8,0v-2H1.99811V48.996A3.02408,3.02408,0,0,0,5.002,52.00189H27.00006v-9.002h2a4,4,0,0,0,0-8Z",
    fill: "#fcb860"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20149",
    d: "M36.99618,62.00391H58.99225A3.02409,3.02409,0,0,0,61.99812,59V37.00194h-9.002v-2a4,4,0,0,0-8,0v2h-8v8h2a4,4,0,0,1,0,8h-2Z",
    fill: "#59e78b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,35v2H49V35a3.98,3.98,0,0,0-2-3.46A3.99444,3.99444,0,0,1,53,35Z",
    fill: "#31e170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,37V59a3.02392,3.02392,0,0,1-3.01,3h-4A3.02392,3.02392,0,0,0,58,59V37Z",
    fill: "#31e170"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Puzzle);
export default __webpack_public_path__ + "static/media/icons8-puzzle.cf8364c6bcc1acbb9027a73ccaf16fbd.svg";
export { ForwardRef as ReactComponent };